webpackJsonp([63],{

/***/ "+kXM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-feedback_91c0ab4b9c57530b8555b783ec942533.html";

/***/ }),

/***/ "rZo5":
/***/ (function(module, exports, __webpack_require__) {

var SectionFeedback = (function () {
    function SectionFeedback() {
    }
    return SectionFeedback;
}());
angular.module('animatronApp.sectionFeedback', []).component('sectionFeedback', {
    bindings: {
        ltTitle: '<',
        list: '<'
    },
    controller: SectionFeedback,
    templateUrl: __webpack_require__("+kXM")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/63-28dc41a6a889e793a2e2.min.js